export const rangeInDates = (dates: string[]) => {
    let lastValue = dates[0];
    let startDate = dates[0];
    let endDate = dates[0];
    const resultArray = []
    for(let i = 1; i< dates.length; i++)
    {
        if(i === (dates.length - 1 ) && dates[i])
        {
            endDate = dates[i];
            resultArray.push({startDate,endDate});

        }
        if(lastValue && dates[i] === '')
        {
            endDate = lastValue;
            resultArray.push({startDate,endDate});
            startDate = '';
            endDate = ''
        }
        else if(lastValue === '' && dates[i])
        {
            startDate = dates[i];
        }
        lastValue = dates[i];
        
    }
    return resultArray;
}